const SuccessAlertMessage = (props: any) => {
  const handleClose = () => {
    props.handleClose();
  };
  return (
    <div className="notification-box">
      <div className="d-flex justify-content-between w-100">
        <div className="icon-message">
          <span className="material-icons">{props.icon}</span>
          <div className="ms-2"> {props.message}</div>
        </div>
        <span className="material-icons fs-4 icon" onClick={handleClose}>
          close
        </span>
      </div>
    </div>
  );
};

export default SuccessAlertMessage;
